import { render, staticRenderFns } from "./workareaAdmin.vue?vue&type=template&id=59bd72a9&scoped=true"
import script from "./workareaAdmin.vue?vue&type=script&lang=js"
export * from "./workareaAdmin.vue?vue&type=script&lang=js"
import style0 from "./workareaAdmin.vue?vue&type=style&index=0&id=59bd72a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd72a9",
  null
  
)

export default component.exports